module.exports = __webpack_public_path__ + "images/internal/datashake/g2crowd.png";